var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useId, useListItem } from '@floating-ui/react';
import { clsx } from 'clsx';
import { Icon } from '@telia-front/icon';
import { useListboxContext } from './listbox-context';
export const ListboxOption = (_a) => {
    var { value, label, description, icon: iconProp, className } = _a, rest = __rest(_a, ["value", "label", "description", "icon", "className"]);
    const { activeIndex, selectedIndex, handleSelect, getItemProps, registerValue, unregisterValue } = useListboxContext();
    const id = useId();
    const { ref, index } = useListItem({ label });
    const active = activeIndex === index;
    const selected = selectedIndex === index;
    const focusable = activeIndex !== null ? active : selectedIndex !== null ? selected : index === 0;
    const labelId = `${id}-label`;
    const descId = `${id}-desc`;
    const icon = selected ? '#check' : iconProp;
    React.useEffect(() => {
        registerValue(value, index);
        return () => {
            unregisterValue(value);
        };
    }, [index, value, registerValue, unregisterValue]);
    return (React.createElement("li", Object.assign({}, rest, { className: clsx('listbox__option', className), id: id, ref: ref, role: "option", "aria-labelledby": labelId, "aria-describedby": descId, "aria-selected": selected, tabIndex: focusable ? 0 : -1 }, getItemProps({
        onClick: () => handleSelect(value),
        onKeyDown: event => {
            switch (event.key) {
                case ' ':
                case 'Enter':
                    event.preventDefault();
                    handleSelect(value);
                    return;
            }
        },
    })),
        icon && React.createElement(Icon, { modifiers: icon, className: "listbox__option-icon", size: "xs" }),
        React.createElement("div", null,
            React.createElement("div", { className: "listbox__option-label", id: labelId }, label),
            React.createElement("div", { className: "listbox__option-desc text-tiny", id: descId }, description))));
};
